<template>
  <v-container>
    <div id="grid-historico">
      <template>
        <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
          <v-icon right dark>arrow_back_ios</v-icon>Volver
        </v-btn>
      </template>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Reporte de archivos del producto:
          {{ producto.descripcion }}</v-toolbar-title
        >
      </v-toolbar>

      <v-layout justify-center>
        <v-flex xs12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            v-if="!alerta"
            :headers="headers"
            :items="itemsProductos"
            :rows-per-page-items="rowsTable"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td width="15%" class="text-xs-left">
                {{ props.item.filename }}
              </td>
              <td width="15%">{{ props.item.usuario }}</td>
              <td width="15%" class="text-xs-left">
                {{ props.item.observaciones }}
              </td>
              <td width="15%" class="text-xs-left">{{ props.item.estado }}</td>
              <td width="15%" class="text-xs-left">
                {{ props.item.fechaModificacion }}
              </td>
              <td width="20%" class="text-xs-left">
                <v-btn
                  v-if="props.item.filename != ''"
                  depressed
                  outline
                  title="Descargar documento"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="downloadFile(props.item.id, props.item.filename)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    props.item.relat == null &&
                    usuarioLoggedTipe == 'AGENCIA' &&
                    props.item.estadoProducto != 3 &&
                    props.item.estadoProducto != 4
                  "
                  depressed
                  outline
                  title="Aprobar/Enviar Observaciones"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="
                    addNewReport(id, code, props.item.id, props.item.filename)
                  "
                >
                  <v-icon>record_voice_over</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    props.item.estadoProducto == 3 &&
                    usuarioLoggedTipe == 'PROVEEDOR'
                  "
                  depressed
                  outline
                  title="Enviar correcciones"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="
                    addNewReport(id, code, props.item.id, props.item.filename)
                  "
                >
                  <v-icon>repeat_one</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.relat == null"
                  depressed
                  outline
                  title="Historia de este reporte"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="
                    viewReporteHistoric(props.item.id, props.item.filename)
                  "
                >
                  <v-icon>history</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <br />
      <v-flex
        v-if="usuarioLoggedTipe == 'PROVEEDOR'"
        xs12
        style="text-align: center"
      >
        <v-card-actions class="pb-3" style="display: inline-block">
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="addNewReport(id, code, null)"
          >
            Subir Nuevo Reporte
            <v-icon right dark>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-flex>
    </div>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "grid-relator",

  components: {
    Loading,
    AlertEmpty,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      descripcionProducto: "",
      producto: "",
      loading: false,
      usuarioLoggedTipe: "",
      loading: false,
      dialog: false,
      alerta: false,
      id: "",
      code: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        {
          text: "Nombre de archivo",
          align: "left",
          sortable: false,
          value: "filename",
        },
        { text: "Usuario", sortable: false, value: "usuario" },
        {
          text: "Observaciones",
          sortable: false,
          value: "observaciones",
        },
        {
          text: "Estado",
          sortable: false,
          value: "estado",
        },
        {
          text: "Fecha Creación",
          sortable: false,
          value: "fecha",
        },
        {
          text: "Descargar Archivo",
          sortable: false,
          value: "estado",
        },
      ],
      itemsProductos: [],
      proceso: "",
    };
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.id = this.$route.params.id;
    this.code = this.$route.params.code;
    this.loadData();
  },

  mounted() {},
  computed: {},
  methods: {
    async loadHistoric() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        idProductosReporte: this.id,
      };
      return await axios
        .post("/productoReporte/historic", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadProduct() {
      return await axios
        .get("/productoReporte/" + this.id + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsProductos = await this.loadHistoric();
      this.producto = await this.loadProduct();
      this.descripcionProducto = this.producto.descripcion;
      if (this.itemsProductos.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    addNewReport(id, code, idReporte, filename) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ProductosRegistraImpresion",
          params: {
            id: id,
            code: code,
            idReporte: idReporte,
            descripcionProducto: this.descripcionProducto,
            filename: filename,
            tipeView: "crear",
          },
        });
      }, 1000);
    },
    volver() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoImpresion",
          params: { tipeView: "consulta" },
        });
      }, 1000);
    },
    viewReporteHistoric(idReporte, filename) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "GridHistoricoImpresionReporte",
          params: {
            id: this.id,
            code: this.code,
            idReporte: idReporte,
            descripcionProducto: this.descripcionProducto,
            filename: filename,
            tipeView: "consulta",
          },
        });
      }, 1000);
    },
    downloadFile(id, filename) {
      let that = this;
      this.body = {
        fileName: filename,
        idContrato: this.idContrato,
        id: id,
      };

      axios
        .post("productoReporte/downloadFile/", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
